import React, {useEffect, useState} from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import PhoneIcon from '@material-ui/icons/Phone';
import CardContent from "@material-ui/core/CardContent";
import {makeStyles} from "@material-ui/core";
import CardActionArea from "@material-ui/core/CardActionArea";
import {useDispatch, useSelector} from "react-redux";
import {selectDealer, setBAC, setDealerEnrollment} from "../../core/redux/ActionCreator";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {solid} from '@fortawesome/fontawesome-svg-core/import.macro'
import Grid from "@material-ui/core/Grid"; // <-- import styles to be used

const useStyles = makeStyles({
    root: {
        borderRadius: 0,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderColor: 'black',
        boxShadow: "none",
    },

    address: {
        paddingBottom: 0
    },

    phoneNumber: {
        display: 'flex',
        alignItems: 'center',
    }
});

function Dealer(props) {
    const classes = useStyles();

    const dispatch = useDispatch();
    const selectedDealer = useSelector(state => state.dealerReducer.selectedDealer);
    const markers = useSelector(state => state.dealerReducer.markers);
    const formattedZipCode = props.dealerAddressObject.zip.substr(0, 5) + '-' + props.dealerAddressObject.zip.substr(5);
    const [isSelected, setIsSelected] = useState(false);
    const brand = useSelector(state => state.appParamsReducer.brand)
    let style;

    switch (brand){
        case 'buick':
            style = '#f26522';
            break;
        case 'cadillac':
            style = '#dbd2b3';
            break;
        case 'chevy':
            style = '#cd9834';
            break;
        case 'gmc':
            style = '#cc0000';
            break;
        default:
            style = '#11365f';
    }

    const handleSelectDealer = (bac) => {
        if (bac) {
            setIsSelected(true);
            dispatch(setDealerEnrollment(props.enrolledDealer));
        }
        if (window.google.maps) {
            window.google.maps.event.trigger(markers[bac], 'click');
        } else {
            dispatch(selectDealer({dealerBAC:bac}));
            dispatch(setBAC(bac));
        }
    };
    const pinLabel = (bac) => {
        let markerItem = markers[bac];
        return (markerItem.label);
    }

    const distanceToDealer = (bac) => {
        let markerItem = markers[bac];
        let dist = markerItem.DistanceToDealer
        return dist.concat(" Miles")
    }

    useEffect(() => {
        if (selectedDealer !== props.dealerBac) {
            setIsSelected(false);
        }
        if (selectedDealer === props.dealerBac) {
            setIsSelected(true);
        }
    }, [selectedDealer, props.dealerBac]);

    return (
        <>
            <Card className={"stat-button-link " + classes.root} data-dtm={"choose dealer"} variant="outlined"
                  style={isSelected ? {border: "2px solid", borderColor: style} : {border: "none"}}>
                <CardActionArea onClick={() => handleSelectDealer(props.dealerBac)}>
                    <Grid container direction="row" alignItems="flex-start" justifyContent="flex-start">
                        <Grid class="pin-padding" item xs={1}>
                            <span class="fa-stack pin">
                            <FontAwesomeIcon class="fa-stack-2x" icon={solid('location-pin')} size="xl" />
                            <p class="fa-stack-1x pin-text">{pinLabel(props.dealerBac)}</p>
                            </span>
                        </Grid>
                        <Grid item xs={10}>
                        <CardHeader title={`${props.dealerName}`} subheader={distanceToDealer(props.dealerBac)}/>
                    <CardContent>
                        <Typography className={classes.address} variant="body1">
                            {props.dealerAddressObject.street}
                        </Typography>
                        <Typography gutterBottom variant="body1">
                            {props.dealerAddressObject.city + ', ' + props.dealerAddressObject.state + ' ' + formattedZipCode}
                        </Typography>
                        <Typography className={classes.phoneNumber} gutterBottom variant="body2">
                            <PhoneIcon/> {props.dealerPhone}
                        </Typography>
                    </CardContent>
                        </Grid>
                    </Grid>
                </CardActionArea>
            </Card>
        </>
    )
}

export default Dealer
